module.exports = __webpack_public_path__ + "img/check_wo_pad.c70f1d2f.svg";